import {call, fork, put, select, take} from "redux-saga/effects";
import {CODES} from "../../constants";
import {getFilters} from "../../reducers/settlements";
import {getUserInfo} from "../../reducers/app";
import API from "../../api/api";
import {getSettlementsPageParam} from "../../reducers/settlements";


export function* getSettlements(object: any): Generator<any, void, any>{
    let userInfo = yield select(getUserInfo)
    let filters = {...yield select(getFilters)}
    for (var key in filters){
        if(filters[key] === -1 || !filters){
            filters[key] = undefined
        }
    }
    let pageParams = yield select(getSettlementsPageParam)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        ...pageParams,
        ...filters,
        ...object.pageParams,
        exportFlag: object.type === 'export' ? 1 : 0
    }
    let resp = yield call(API.getSettlementList, params)
    if (resp.code === CODES.SUCCESS && resp.data) {
        yield put({type: 'SET_SETTLEMENTS', payload: {data: resp.data, pageParams: object.pageParams}})
    }
}

export function* watchSettlements(): Generator<any, void, any>{
    while (true){
        let {payload} = yield take('GET_SETTLEMENTS')
        yield fork(getSettlements, payload)
    }
}